import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { withRouter } from 'react-router-dom';
import SearchSuggestions from './SearchSuggestions';
import SearchPanelResults from './SearchPanelResults';
import SearchField from '../SearchField/SearchFieldContainer';

export class SearchPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPanelVisible: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      const { onCloseClick, pill } = this.props;
      if (onCloseClick) onCloseClick();
      if (pill) this.handleClose();
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  handleClickOutside(event) {
    event.stopPropagation();
    const { onCloseClick } = this.props;
    this.handleClose();
    if (onCloseClick) onCloseClick();
  }

  handleFocus() {
    this.setState({ isPanelVisible: true });
  }

  handleSubmit() {
    const { onCloseClick, query, history } = this.props;
    this.handleClose();
    history.push(`/search?query=${query}`);
    if (onCloseClick) onCloseClick();
  }

  handleClose() {
    this.setState({ isPanelVisible: false });
  }

  renderLayout() {
    const { hits, onCloseClick, query } = this.props;
    return (
      <div>
        <div className="relative pa3 bg-near-white">
          <button
            type="button"
            className="outline-0 pa0 ma0 bn absolute top-1 right-1 bg-none pointer"
            data-id="search-panel-close"
            onClick={onCloseClick}
          >
            <span className="f4 icon-x mid-gray" />
          </button>
          <h2 className="pa0 mt0 mb2 f3" data-id="search-panel-title">
            Search
          </h2>
          <SearchField onSubmit={this.handleSubmit} query={query} instant small />
        </div>
        {hits ? <SearchPanelResults {...this.props} /> : <SearchSuggestions />}
      </div>
    );
  }

  renderPillLayout() {
    const { hits, pill, query } = this.props;
    const { isPanelVisible } = this.state;
    return (
      <div>
        <SearchField
          onFocus={this.handleFocus}
          onSubmit={this.handleSubmit}
          pill={pill}
          query={query}
          instant
        />
        {hits && query ? (
          <div
            className={`absolute left-0 z-3 pb3 w-100 bg-white bt-0 ba b--light-gray ${
              isPanelVisible ? 'db' : 'dn'
            }`}
            style={{ top: '100%', maxWidth: '24rem' }}
          >
            <SearchPanelResults {...this.props} />
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { pill } = this.props;
    const styles = `${!pill ? 'relative z-3 shadow-3 bg-white ba b--moon-gray futura-heavy' : ''}`;
    return (
      <div className={`search-panel ${styles}`} style={{ width: '24rem' }}>
        {pill ? this.renderPillLayout() : this.renderLayout()}
      </div>
    );
  }
}

SearchPanel.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape({})),
  onCloseClick: PropTypes.func,
  pill: PropTypes.bool,
  query: PropTypes.string,
};

SearchPanel.defaultProps = {
  hits: null,
  onCloseClick: () => {},
  pill: false,
  query: '',
};

export default withRouter(onClickOutside(SearchPanel));
